<template>
    <div class="pa-3" v-if="companyId">
        <v-row no-gutters class="mb-2 rounded-xl bg-white">
            <v-col cols="12" class="d-flex align-center">
                <v-btn-back class="ml-2" @click="back()"> </v-btn-back>
                <v-select-filled
                    v-model="selectedView"
                    :items="viewsToDisplay"
                    outlined
                    class="mx-2"
                    hide-details
                    style="width: 80px"
                    data-cy="TaxFormManager-selectedView"
                    density="compact"
                    item-title="text"
                    item-value="value"
                />
                <div v-if="selectedView === 'booklet'">
                    <v-select-filled
                        v-model="selectedTemplateTemp"
                        :items="bookletTemplates"
                        class="mr-2"
                        item-value="id"
                        item-title="name"
                        hide-details
                        return-object
                        @update:modelValue="onBookletTemplateChange"
                        density="compact"
                        v-if="bookletTemplates && bookletTemplates.length"
                    />
                </div>
                <v-spacer />
                <v-btn-toggle
                    v-model="formDisplayMode"
                    class="ml-6"
                    mandatory="force"
                    density="compact"
                    group
                    rounded
                    v-if="selectedTaxFormIndex !== 0 && selectedView !== 'booklet'"
                >
                    <v-btn value="TaxFormTable" data-cy="TaxFormManager-saisie"> Saisie </v-btn>
                    <v-btn value="TaxFormPng" data-cy="TaxFormManager-cerfa"> Cerfa </v-btn>
                </v-btn-toggle>
                <v-spacer v-if="companyBundleType !== 'BNC'" />
                <!-- <h4 v-if="companyBundleType !== 'BNC'" style="color: red;">(Version alpha)</h4> -->
                <v-spacer />
                <v-tooltip v-if="selectedView === 'bundle'" location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn-icon
                            class="mr-2 mt-1"
                            rounded="circle"
                            elevation="0"
                            v-bind="props"
                            @click="openGeneralLedger()"
                            icon="$oss-general-ledger"
                            color="primary"
                        >
                        </v-btn-icon>
                    </template>
                    <span>Balance / Grand-Livre</span>
                </v-tooltip>
                <div v-if="bundleDependenciesErrors && !isSent">
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-warning
                                class="mr-2 mt-1"
                                v-bind="props"
                                @click="toggleDependenciesErrorsDialog()"
                            >
                            </v-btn-warning>
                        </template>
                        <span>Champs manquants</span>
                    </v-tooltip>
                </div>
                <!-- <v-spacer></v-spacer> -->
                <v-tooltip v-if="selectedView === 'bundle' && !isSent" location="bottom">
                    <template v-slot:activator="{ props }">
                        <v-btn
                            class="mr-2 mt-1"
                            size="small"
                            fab
                            elevation="0"
                            v-bind="props"
                            color="#FFF"
                            @click="toggleChecksDialog()"
                        >
                            <v-badge color="red" :content="errorsCount">
                                <v-icon class="pb-1" color="primary" size="x-large"
                                    >$oss-warning</v-icon
                                >
                            </v-badge>
                        </v-btn>
                    </template>
                    <span>Contrôles de cohérence</span>
                </v-tooltip>
                <v-btn
                    :disabled="isSaveDisabled"
                    rounded
                    elevation="0"
                    class="mr-2"
                    @click="saveBundle()"
                    data-cy="TaxFormManager-save"
                    size="small"
                >
                    Enregistrer
                </v-btn>
                <v-tooltip
                    :disabled="!bundleId"
                    location="bottom"
                    v-if="company && company.taxSystemType === 'IS'"
                >
                    <template v-slot:activator="{ props }">
                        <div v-bind="props">
                            <v-btn
                                :disabled="!bundleId"
                                rounded
                                elevation="0"
                                class="mr-2"
                                @click="
                                    $router.push({
                                        name: 'corporate-tax',
                                        params: {
                                            companyId: companyId,
                                            accountingPeriodId: accountingPeriodId,
                                            acKey: 'yZCapzwZiGhZ81RFS40tDW8i',
                                        },
                                    })
                                "
                                size="small"
                            >
                                Calcul IS
                            </v-btn>
                        </div>
                    </template>
                    <span
                        >Lien vers le dossier de révision - "Contrôle de calcul et comptabilisation
                        de l'Impôt sur les Sociétés"</span
                    >
                </v-tooltip>
                <v-tooltip v-if="isTrainingOffer">
                    <template #activator="{ props }">
                        <v-btn
                            :disabled="true"
                            rounded
                            elevation="0"
                            class="mr-2"
                            size="small"
                            v-bind="props"
                        >
                            Télédéclaration
                        </v-btn>
                    </template>
                    <span>{{ $t("training-text.normal-text") }}</span>
                </v-tooltip>
                <v-tooltip
                    v-else-if="
                        isSendBundleDisabled &&
                        bundle &&
                        bundle.unaffectedAccounts &&
                        bundle.unaffectedAccounts.length
                    "
                    text="                     
                        Un ou plusieurs comptes de la balance ne sont pas affectés dans la liasse
                    "
                    location="bottom"
                >
                    <template #activator="{ props }">
                        <span v-bind="props" style="display: inline-block">
                            <v-btn
                                :disabled="true"
                                rounded
                                elevation="0"
                                class="mr-2"
                                size="small"
                                @click="openBundleDeclarationDialog()"
                            >
                                Télédéclaration
                            </v-btn>
                        </span>
                    </template>
                </v-tooltip>
                <v-btn
                    v-else
                    :disabled="isSendBundleDisabled"
                    rounded
                    elevation="0"
                    class="mr-2"
                    size="small"
                    @click="openBundleDeclarationDialog()"
                >
                    Télédéclaration
                </v-btn>
                <v-menu offset-y :close-on-content-click="false">
                    <template v-slot:activator="{ props }">
                        <v-btn-icon
                            icon="$dots_vertical"
                            v-bind="props"
                            class="d-flex align-center"
                        />
                    </template>
                    <v-list>
                        <v-list-item @click="instructionsDialog = true">
                            <v-list-item-title>Notice d'utilisation</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-help</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item :disabled="isSent" class="pr-2">
                            <v-list-item-title>Autoriser la modification</v-list-item-title>
                            <template v-slot:append>
                                <v-switch v-model="enableEdition" hide-details />
                            </template>
                        </v-list-item>
                        <v-list-item :disabled="isSent" @click="refreshGeneralLedger()">
                            <v-list-item-title>Recalculer la balance</v-list-item-title>
                            <template v-slot:append>
                                <v-icon :disabled="isSent" size="small">$fa-redo-alt</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item
                            :disabled="isSent"
                            @click="
                                createRows();
                                miscellaneousOperationDialog = true;
                            "
                        >
                            <v-list-item-title>Passage d'OD</v-list-item-title>
                            <template v-slot:append>
                                <v-icon :disabled="isSent" size="small">$oss-edit</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item
                            @click="openPrintFormsDialog(false)"
                            :disabled="!referencedForms || !referencedForms.length"
                        >
                            <v-list-item-title>Impression</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-download</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item @click="generateBookletDialog = true" :disabled="!bundleId">
                            <v-list-item-title>Plaquette</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-file</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item @click="updateDeclarationStatus()">
                            <v-list-item-title>Mettre à jour le statut</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$fa-redo-alt</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item @click="duplicateBundle()">
                            <v-list-item-title>Dupliquer la liasse</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-duplicate</v-icon>
                            </template>
                        </v-list-item>
                        <v-list-item v-if="duplicateBundleLoading">
                            <v-progress-circular
                                indeterminate
                                size="28"
                                color="primary"
                                class="mx-auto"
                            />
                        </v-list-item>
                        <TaxFormEDIReport :taxFormId="bundleId">
                            <template #default="{ statusOk, mtaeProof }">
                                <v-list-item :disabled="!isSent || !statusOk" @click="mtaeProof">
                                    <v-list-item-title
                                        >Impression justificatf EDI</v-list-item-title
                                    >
                                    <template v-slot:append>
                                        <v-icon size="small">$oss-download</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </TaxFormEDIReport>
                        <v-list-item
                            v-if="isSent && isUserAuthorized && xml"
                            @click="downloadXMLFile()"
                        >
                            <v-list-item-title>Télécharger le fichier XML</v-list-item-title>
                            <template v-slot:append>
                                <v-icon size="small">$oss-download</v-icon>
                            </template>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-col>
        </v-row>
        <v-row no-gutters style="flex-wrap: nowrap">
            <v-col cols="2" class="fill-height border-none flex-grow-0 flex-shrink-1 mr-2">
                <div
                    style="height: calc(100vh - 232px); overflow-y: auto"
                    :key="referencedFormRefreshKey"
                >
                    <v-tabs
                        direction="vertical"
                        v-model="selectedTaxFormIndex"
                        class="rounded-xl"
                        color="primary"
                    >
                        <v-tab class="d-flex justify-start" value="-1">{{ firstTabTitle }} </v-tab>
                        <v-tab v-if="!loaded" class="d-flex justify-center align-center">
                            <v-progress-circular
                                color="primary"
                                indeterminate
                                size="28"
                                class="mx-auto"
                            />
                        </v-tab>
                        <template v-else-if="referencedForms">
                            <v-tab
                                v-for="(sheet, index) of referencedForms"
                                :value="index + 1"
                                class="d-flex justify-space-between"
                                :model-value="sheet.cerfaNumber"
                            >
                                <v-tooltip location="end" activator="parent">
                                    <template v-slot:activator="{ props }">
                                        <p
                                            v-bind="props"
                                            class="mb-0"
                                            :data-cy="'TaxFormManager-name-' + index"
                                        >
                                            {{
                                                selectedView === "bundle"
                                                    ? displayCerfaName(sheet)
                                                    : cleanSheetTitle(sheet)
                                            }}
                                        </p>
                                        <v-spacer />
                                    </template>
                                    <span>{{
                                        selectedView === "bundle"
                                            ? sheet.title
                                            : displayCerfaName(sheet)
                                    }}</span>
                                </v-tooltip>
                                <v-btn-trash
                                    v-if="
                                        selectedView === 'bundle' &&
                                        !isMandatoryForm(sheet.cerfaNumber) &&
                                        !isSent
                                    "
                                    @click.stop="openDialogToDeleteBundleSheetFromForm(sheet)"
                                    size="small"
                                />
                            </v-tab>
                        </template>
                    </v-tabs>
                </div>
                <div class="pa-2 d-flex align-center justify-center">
                    <v-btn
                        :disabled="isSent"
                        rounded
                        elevation="0"
                        block
                        v-if="selectedView === 'bundle'"
                        @click="openAddFormDialog()"
                        size="small"
                    >
                        <span class="subtitle-1 white--text">+</span>
                    </v-btn>
                </div>
                <oss-dialog v-model="addFormDialog" title="Ajouter un formulaire à la liasse">
                    <v-row no-gutters class="py-1" style="width: 750px">
                        <v-col cols="12">
                            <v-text-field-filled
                                v-model="searchForm"
                                label="Rechercher"
                                outlined
                                hide-details
                                density="compact"
                                append-inner-icon="$search"
                                clearable
                                @click:clear="searchForm = ''"
                            />
                        </v-col>
                        <v-col cols="12" style="max-height: calc(100vh - 200px); overflow-y: auto">
                            <v-list two-lines>
                                <v-list-item
                                    v-for="(form, index) in filteredOptionalForms"
                                    :key="index"
                                    @click="formToAdd(form)"
                                    two-lines
                                >
                                    <v-list-item-title>{{ form.cerfa }}</v-list-item-title>
                                    <v-list-item-subtitle style="white-space: break-spaces">{{
                                        form.title
                                    }}</v-list-item-subtitle>
                                </v-list-item>
                                <v-list-item v-if="!filteredOptionalForms.length" two-lines>
                                    <v-list-item-title
                                        >Aucun formulaire trouvé pour ce résultat</v-list-item-title
                                    >
                                </v-list-item>
                            </v-list>
                        </v-col>
                    </v-row>
                </oss-dialog>
            </v-col>
            <v-col
                cols="10"
                class="px-2 flex-grow-1 flex-shrink-0 document-card"
                style="max-height: calc(100vh - 150px); overflow: auto"
            >
                <div
                    v-if="!accountingPeriodId"
                    class="d-flex align-center justify-center fill-height"
                >
                    Pour pouvoir accéder au formulaire, veuillez sélectionner une periode comptable.
                </div>
                <v-window v-else v-model="selectedTaxFormIndex">
                    <v-window-item :key="0" :value="0">
                        <BundleDetails
                            @variablesUpdated="fixedVariablesUpdated($event)"
                            @variablesFetched="fixedVariablesFetched($event)"
                            @shareQuantityDifferenceIsOverZero="
                                shareQuantityDifferenceIsOverZero = true
                            "
                            :bundleId="bundleId"
                            :isSent="isSent"
                            v-show="selectedView === 'bundle'"
                        />
                        <BookletGenerator
                            v-if="bundle && bundle.bookletTemplate"
                            v-model="bundle.bookletTemplate"
                            @changeBookletGenerator="onBookletChange($event)"
                            v-show="selectedView === 'booklet'"
                            :bundleType="bundleType"
                            :importFilesMillesimfromBundle="
                                bundle ? bundle.importFilesMillesim : null
                            "
                        >
                        </BookletGenerator>
                    </v-window-item>
                    <v-window-item
                        v-for="(sheet, index) of referencedForms"
                        :key="index + 1"
                        :value="index + 1"
                    >
                        <div>
                            <!-- <template v-if="sheet.form.type === 'multiple-page'">
                                <TaxForm
                                    v-for="f in sheet.form.forms"
                                    :key="f.cerfa"
                                    ref="taxForm"
                                    :cerfaNumber="f.cerfa"
                                    :year="selectedYear"
                                    :activeTab="formDisplayMode"
                                    :sheet="getBundleSheet(f.cerfa)"
                                    :loaded="loaded"
                                    :enableEdition="enableEdition"
                                    :isSent="isSent && selectedView === 'bundle'"
                                    @fieldUpdate="onTaxFormChanged"
                                    @additionnal-page-created="additionnalPageCreated"
                                >
                                </TaxForm>
                            </template>
                            <template v-else> -->
                            <TaxForm
                                ref="taxForm"
                                :cerfaNumber="sheet.cerfaNumber"
                                :activeTab="formDisplayMode"
                                :sheet="sheet"
                                :loaded="loaded"
                                :enableEdition="enableEdition"
                                :isSent="isSent && selectedView === 'bundle'"
                                @fieldUpdate="onTaxFormChanged"
                                @additionnal-page-created="additionnalPageCreated"
                            />
                            <!-- </template> -->
                        </div>
                    </v-window-item>
                </v-window>
            </v-col>
        </v-row>
        <oss-dialog
            v-if="toDeleteDialog"
            v-model="toDeleteDialog"
            title="Suppression d'un formulaire"
            @valid="deleteBundleSheet()"
        >
            <div class="text-center" style="width: 750px">
                &#xca;tes-vous sûr(e) de vouloir supprimer le formulaire
                {{ displayCerfaName(toDeleteSheet) }} ?
            </div>
        </oss-dialog>
        <oss-dialog
            v-if="dependenciesErrorsDialog"
            v-model="dependenciesErrorsDialog"
            title="Champs manquants"
            valid-title="Fermer"
            @valid="dependenciesErrorsDialog = false"
            @close="dependenciesErrorsDialog = false"
        >
            <v-row
                no-gutters
                :key="index1"
                v-for="(form, index1) of bundleDependenciesErrors"
                style="width: 750px"
            >
                <v-col cols="12" class="text-left"> {{ form.cerfa }} : </v-col>
                <v-col
                    cols="12"
                    :key="index1 + '_' + index2"
                    v-for="(error, index2) of form.errors"
                >
                    <v-row no-gutters>
                        <v-col cols="2" />
                        <v-col cols="10">
                            Champ concerné : {{ error.function }} - Champ manquant :
                            {{ error.field }}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="generalLedgerDialog"
            title="Balance de l'exercice"
            valid-title="Fermer"
            @valid="generalLedgerDialog = false"
            @close="generalLedgerDialog = false"
        >
            <div style="width: 1100px">
                <GeneralLedger
                    ref="balances"
                    :companyId="companyId"
                    :accountingPeriodId="accountingPeriodId"
                    :hideOptions="true"
                    :inNm1="true"
                    :tableHeight="'63vh'"
                    :bundleGeneralLedger="bundle && bundle.balances ? bundle.balances : null"
                >
                </GeneralLedger>
            </div>
        </oss-dialog>
        <oss-dialog
            v-if="checksDialog"
            v-model="checksDialog"
            title="Contrôle de cohérence"
            :error="wantToDeclare"
            :valid-title="checksDialogValidTitle"
            :previous-display="checksWindow === 'balanceErrors'"
            @previous="checksWindow = 'allChecks'"
            @valid="checksDialogValidFunction()"
            @close="
                checksDialog = false;
                checksWindow = 'allChecks';
            "
        >
            <v-window v-model="checksWindow" style="width: 750px">
                <v-window-item value="allChecks">
                    <v-row no-gutters class="mb-2">
                        <v-col cols="12" class="d-flex justify-start">
                            <v-switch
                                v-model="bundle.showAllConsistencyChecks"
                                label="Afficher tous les contrôles"
                                class="ml-5"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <template
                                v-if="
                                    bundle.allChecksValid &&
                                    !bundle.showAllConsistencyChecks &&
                                    !isBalanceError &&
                                    !isFixedAssetsError &&
                                    !invalidFixedVariablesCount &&
                                    accountsBalanceAnomaliesCount === 0
                                "
                            >
                                <b class="text-center my-5">
                                    <v-icon class="mr-2">$oss-circle-check</v-icon>
                                    Tous les contrôles ont été validés
                                </b>
                            </template>
                            <template v-else>
                                <v-list class="mb-5">
                                    <!-- fixed variables checks -->
                                    <v-list-item
                                        class="mt-5"
                                        v-if="
                                            invalidFixedVariablesCount ||
                                            bundle.showAllConsistencyChecks
                                        "
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-icon
                                                    :color="
                                                        invalidFixedVariablesCount
                                                            ? 'red'
                                                            : 'primary'
                                                    "
                                                >
                                                    {{
                                                        invalidFixedVariablesCount
                                                            ? "$oss-warning"
                                                            : "$oss-circle-check"
                                                    }}
                                                </v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <v-list-item-title>
                                                    Variables fixes
                                                </v-list-item-title>
                                                <v-list-item-subtitle
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                >
                                                    {{
                                                        invalidFixedVariablesCount
                                                            ? "Toutes les variables fixes n'ont pas été renseignées"
                                                            : "Toutes les variables fixes ont été renseignées"
                                                    }}
                                                </v-list-item-subtitle>
                                            </v-col>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-btn
                                                    rounded="circle"
                                                    elevation="0"
                                                    @click="
                                                        selectedTaxFormIndex = 0;
                                                        checksDialog = false;
                                                    "
                                                    size="small"
                                                    icon="$oss-eye"
                                                >
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <!-- bundle vs accounting check -->
                                    <v-list-item
                                        class="mt-5"
                                        v-if="isBalanceError || bundle.showAllConsistencyChecks"
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-icon
                                                    :color="isBalanceError ? 'red' : 'primary'"
                                                    >{{
                                                        isBalanceError
                                                            ? "$oss-warning"
                                                            : "$oss-circle-check"
                                                    }}</v-icon
                                                >
                                            </v-col>
                                            <v-col cols="10">
                                                <v-list-item-title>
                                                    Contrôle de la balance
                                                </v-list-item-title>
                                                <v-list-item-subtitle
                                                    v-if="isBalanceError"
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                >
                                                    La balance comptable et la balance de la liasse
                                                    sont différentes
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    v-else
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                >
                                                    La balance comptable et la balance de la liasse
                                                    sont identiques
                                                </v-list-item-subtitle>
                                            </v-col>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-btn
                                                    rounded="circle"
                                                    elevation="0"
                                                    v-if="isBalanceError"
                                                    @click="checksWindow = 'balanceErrors'"
                                                    size="small"
                                                    icon="$oss-eye"
                                                >
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <!-- unaffected accounts checks -->
                                    <v-list-item
                                        class="mt-5"
                                        v-if="
                                            bundle.unaffectedAccounts.length ||
                                            bundle.showAllConsistencyChecks
                                        "
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-icon
                                                    :color="
                                                        bundle.unaffectedAccounts.length
                                                            ? 'red'
                                                            : 'primary'
                                                    "
                                                >
                                                    {{
                                                        bundle.unaffectedAccounts.length
                                                            ? "$oss-warning"
                                                            : "$oss-circle-check"
                                                    }}
                                                </v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <v-list-item-title>
                                                    Affectation des comptes de la balance
                                                </v-list-item-title>
                                                <v-list-item-subtitle
                                                    v-if="bundle.unaffectedAccounts.length"
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                >
                                                    {{
                                                        `${
                                                            bundle.unaffectedAccounts.length > 1
                                                                ? "Plusieurs comptes de la balance n'ont pas été affectés"
                                                                : "Un compte de la balance n'a pas été affecté"
                                                        } dans la liasse`
                                                    }}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    v-else
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                >
                                                    Tous les comptes ont été affectés
                                                </v-list-item-subtitle>
                                            </v-col>
                                            <v-col cols="1" />
                                        </v-row>
                                    </v-list-item>
                                    <!-- fixed assets checks -->
                                    <v-list-item
                                        class="mt-5"
                                        v-if="isFixedAssetsError || bundle.showAllConsistencyChecks"
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-icon
                                                    :color="isFixedAssetsError ? 'red' : 'primary'"
                                                >
                                                    {{
                                                        isFixedAssetsError
                                                            ? "$oss-warning"
                                                            : "$oss-circle-check"
                                                    }}
                                                </v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <v-list-item-title>
                                                    Contrôle des immobilisations
                                                </v-list-item-title>
                                                <v-list-item-subtitle
                                                    v-if="isFixedAssetsError"
                                                    class="mt-1 long-subtitle"
                                                >
                                                    {{ bundle.fixedAssetsErrorMessage }}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle
                                                    v-else
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                    >Pas d'erreur au niveau des immobilisations
                                                </v-list-item-subtitle>
                                            </v-col>
                                            <v-col cols="1" />
                                        </v-row>
                                    </v-list-item>
                                    <!-- accounts balance checks -->
                                    <v-list-item
                                        class="mt-5"
                                        v-if="
                                            accountsBalanceAnomaliesCount === 0 &&
                                            bundle.showAllConsistencyChecks
                                        "
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-icon color="primary">$oss-circle-check</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <v-list-item-title>
                                                    Soldes de la balance
                                                </v-list-item-title>
                                                <v-list-item-subtitle
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                >
                                                    Aucune anomalie sur les soldes de la balance
                                                </v-list-item-subtitle>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                    <template v-else>
                                        <v-list-item
                                            class="mt-5"
                                            v-for="account in accountsBalanceAnomalies"
                                            :key="account.name"
                                        >
                                            <v-row no-gutters>
                                                <v-col
                                                    cols="1"
                                                    class="d-flex justify-center align-center"
                                                >
                                                    <v-icon color="red">$oss-warning</v-icon>
                                                </v-col>
                                                <v-col cols="10">
                                                    <v-list-item-title>
                                                        Compte {{ account.name }}
                                                    </v-list-item-title>
                                                    <v-list-item-subtitle
                                                        class="mt-1 long-subtitle"
                                                    >
                                                        {{ account.anomaly }}
                                                    </v-list-item-subtitle>
                                                </v-col>
                                            </v-row>
                                        </v-list-item>
                                    </template>
                                    <!-- tax number SCI associates check -->
                                    <v-list-item class="mt-5" v-if="missingTaxNumberSCIAssociates">
                                        <v-row no-gutters>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-icon color="red">$oss-warning</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <v-list-item-title>
                                                    Contrôle des numéros fiscaux
                                                </v-list-item-title>
                                                <v-list-item-subtitle
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                >
                                                    Le numéro fiscal n'est pas rempli pour tous les
                                                    associés personne physique
                                                </v-list-item-subtitle>
                                            </v-col>
                                            <v-col cols="1" />
                                        </v-row>
                                    </v-list-item>
                                    <!-- shares check -->
                                    <v-list-item
                                        class="mt-5"
                                        v-if="shareCapitalIsNotFullyAllocated"
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-icon color="red">$oss-warning</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <v-list-item-title>
                                                    Répartition du capital
                                                </v-list-item-title>
                                                <v-list-item-subtitle
                                                    class="mt-1"
                                                    style="white-space: normal"
                                                >
                                                    Le capital social n'est pas réparti à 100%
                                                </v-list-item-subtitle>
                                            </v-col>
                                            <v-col cols="1" />
                                        </v-row>
                                    </v-list-item>
                                    <!-- consistency checks -->
                                    <v-list-item
                                        v-for="(item, key, index) in filteredConsistencyChecks"
                                        :key="index"
                                        class="mt-5"
                                    >
                                        <v-row no-gutters>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-icon :color="item.iconColor">{{
                                                    item.icon
                                                }}</v-icon>
                                            </v-col>
                                            <v-col cols="10">
                                                <v-list-item-title>
                                                    {{ item.label }}
                                                </v-list-item-title>
                                                <v-list-item-subtitle class="mt-1 long-subtitle">
                                                    {{ item.textError }}
                                                </v-list-item-subtitle>
                                            </v-col>
                                            <v-col
                                                cols="1"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-btn
                                                    rounded="circle"
                                                    elevation="0"
                                                    @click="showCellToCheck(item.cerfa)"
                                                    size="small"
                                                    icon="$oss-eye"
                                                >
                                                </v-btn>
                                            </v-col>
                                            <v-col
                                                cols="12"
                                                v-if="
                                                    item.subConsistencyChecks &&
                                                    !item.subConsistencyChecks.allChecksValid
                                                "
                                            >
                                                <v-row no-gutters>
                                                    <v-col cols="1" />
                                                    <v-col cols="11">
                                                        <v-row
                                                            no-gutters
                                                            :key="index"
                                                            v-for="(subItem, key, index) in item
                                                                .subConsistencyChecks
                                                                .filteredChecks"
                                                        >
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex justify-center align-center"
                                                            >
                                                                <v-icon
                                                                    :color="subItem.iconColor"
                                                                    >{{ subItem.icon }}</v-icon
                                                                >
                                                            </v-col>
                                                            <v-col cols="10">
                                                                <v-list-item-title>
                                                                    {{ subItem.label }}
                                                                </v-list-item-title>
                                                                <v-list-item-subtitle
                                                                    class="mt-1 long-subtitle"
                                                                >
                                                                    {{ subItem.textError }}
                                                                </v-list-item-subtitle>
                                                            </v-col>
                                                            <v-col
                                                                cols="1"
                                                                class="d-flex justify-center align-center"
                                                            >
                                                                <v-btn
                                                                    rounded="circle"
                                                                    elevation="0"
                                                                    @click="
                                                                        showCellToCheck(
                                                                            subItem.cerfa,
                                                                        )
                                                                    "
                                                                    size="small"
                                                                    icon="$oss-eye"
                                                                >
                                                                </v-btn>
                                                            </v-col>
                                                        </v-row>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                        </v-row>
                                    </v-list-item>
                                </v-list>
                            </template>
                        </v-col>
                    </v-row>
                </v-window-item>
                <v-window-item value="balanceErrors">
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-row no-gutters class="d-flex justify-center my-5">
                                <b>
                                    <v-icon class="mr-2" color="red">$oss-warning</v-icon>
                                    La balance comptable est différente de la balance de la liasse
                                </b>
                            </v-row>
                            <v-row
                                no-gutters
                                v-if="balanceErrors.aasWithdifferentBalance.length"
                                class="mt-3"
                            >
                                <v-col cols="12" class="mb-2 pl-5">
                                    <h4>Comptes dont le solde a changé :</h4>
                                </v-col>
                                <v-col cols="1" />
                                <v-col cols="4" class="d-flex justify-start mb-2">
                                    <b>Compte</b>
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end mb-2">
                                    <b>Solde compta</b>
                                </v-col>
                                <v-col cols="3" class="d-flex justify-end mb-2">
                                    <b>Solde liasse</b>
                                </v-col>
                                <v-col cols="1" />
                                <v-col cols="12">
                                    <v-row
                                        no-gutters
                                        v-for="aa of balanceErrors.aasWithdifferentBalance"
                                        :key="aa.id"
                                    >
                                        <v-col cols="1" />
                                        <v-col cols="4" class="d-flex justify-start mb-2">
                                            {{ aa.aaName }}
                                        </v-col>
                                        <v-col cols="3" class="d-flex justify-end mb-2">
                                            {{
                                                newCommonFormatCurrency(
                                                    Math.abs(aa.aaAccountingBalance),
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                        <v-col cols="3" class="d-flex justify-end mb-2">
                                            {{
                                                newCommonFormatCurrency(
                                                    Math.abs(aa.bundleGlBalance),
                                                    undefined,
                                                )
                                            }}
                                        </v-col>
                                        <v-col cols="1" />
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row
                                no-gutters
                                v-if="balanceErrors.missingAasInAccountingBalance.length"
                                class="mt-3"
                            >
                                <v-col cols="12" class="mb-2 pl-5">
                                    <h4>
                                        Comptes présents dans la liasse mais pas dans la
                                        comptabilité :
                                    </h4>
                                </v-col>
                                <template
                                    v-for="(
                                        aa, index
                                    ) of balanceErrors.missingAasInAccountingBalance"
                                    :key="aa + index"
                                >
                                    <v-col cols="1" />
                                    <v-col cols="5" class="d-flex justify-start mb-2">
                                        {{ aa }}
                                    </v-col>
                                </template>
                            </v-row>
                            <v-row
                                no-gutters
                                v-if="balanceErrors.missingAasInBundleBalance.length"
                                class="mt-3"
                            >
                                <v-col cols="12" class="mb-2 pl-5">
                                    <h4>
                                        Comptes présents dans la comptabilité mais pas dans la
                                        liasse :
                                    </h4>
                                </v-col>
                                <template
                                    v-for="(aa, index) of balanceErrors.missingAasInBundleBalance"
                                    :key="aa + index"
                                >
                                    <v-col cols="1" />
                                    <v-col cols="5" class="d-flex justify-start mb-2">
                                        {{ aa }}
                                    </v-col>
                                </template>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-window-item>
            </v-window>
        </oss-dialog>
        <oss-dialog
            v-if="confirmCloseWithoutSaveDialog"
            v-model="confirmCloseWithoutSaveDialog"
            title="Attention"
            :valid-display="false"
            @close="
                confirmCloseWithoutSaveDialog = false;
                resetRouterNext();
            "
            data-cy="TaxFormManager-valid"
        >
            <v-row no-gutters style="width: 750px">
                <v-col cols="12" class="d-flex justify-center align-center">
                    <b>&#xca;tes-vous sûr(e) de vouloir quitter sans enregistrer ?</b>
                </v-col>
                <v-col cols="12" class="d-flex justify-center align-center mt-5">
                    <v-btn
                        rounded
                        elevation="0"
                        class="mr-2 mt-1"
                        @click="saveAndExit()"
                        size="small"
                    >
                        Enregistrer et quitter
                    </v-btn>
                    <v-btn
                        rounded
                        elevation="0"
                        class="ml-2 mt-1"
                        outlined
                        @click="
                            confirmCloseWithoutSaveDialog = false;
                            needSave = false;
                            exit();
                        "
                        size="small"
                    >
                        Quitter sans enregistrer
                    </v-btn>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog v-model="miscellaneousOperationDialog" :actions="actionsMiscellaneousOperation">
            <div style="width: 1100px">
                <AccountingItemEdition2
                    v-if="miscellaneousOperationDialog"
                    :prefilledRows="miscellanousOperationData"
                    :companyId="companyId"
                    @upsert="refreshGeneralLedger()"
                    :actions="actionsMiscellaneousOperation"
                >
                </AccountingItemEdition2>
            </div>
        </oss-dialog>
        <oss-dialog
            v-model="printFormsDialog"
            v-if="printFormsDialog"
            title="Impression des formulaires"
            valid-title="Imprimer"
            :validDisabled="!formsSelected.length"
            @valid="printForms()"
            @close="printFormsDialog = false"
        >
            <v-row no-gutters style="width: 375px">
                <v-col cols="12" class="d-flex justify-center">
                    <v-radio-group v-model="printFormsMode" inline hide-details>
                        <v-radio label="Saisie" value="html" color="primary" />
                        <v-radio
                            v-if="selectedView === 'bundle'"
                            label="Cerfa"
                            value="png"
                            color="primary"
                        />
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12">
                    <v-checkbox
                        v-model="exportWithProjectWatermark"
                        :ripple="false"
                        class=""
                        :title="$t('shared.exportWithProjectWatermark')"
                        :label="$t('shared.exportWithProjectWatermark')"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex justify-center">
                    <v-btn
                        rounded
                        elevation="0"
                        class="mr-2 mt-1"
                        @click="selectAll()"
                        size="small"
                    >
                        Tout sélectionner
                    </v-btn>
                    <v-btn
                        outlined
                        rounded
                        elevation="0"
                        class="ml-2 mt-1"
                        @click="clearAll()"
                        size="small"
                    >
                        Tout désélectionner
                    </v-btn>
                </v-col>
            </v-row>
            <v-list>
                <v-list-item v-for="(sheet, index) in referencedForms" :key="index">
                    <v-list-item-title>{{
                        selectedView === "bundle" ? displayCerfaName(sheet) : cleanSheetTitle(sheet)
                    }}</v-list-item-title>
                    <template v-slot:append>
                        <v-checkbox
                            v-model="formsSelected"
                            :value="sheet.cerfaNumber"
                            color="primary"
                        />
                    </template>
                </v-list-item>
            </v-list>
        </oss-dialog>
        <oss-dialog
            v-model="bundleDeclarationDialog"
            v-if="bundleDeclarationDialog"
            title="Validation avant envoi"
            :valid-loading="sendBundleDialogLoading"
            valid-title="Télédéclarer"
            :valid-disabled="!formsToSend.length || !recipients.length"
            @valid="generateXML()"
            @close="
                bundleDeclarationDialog = false;
                formsToSend = [];
            "
        >
            <v-row no-gutters style="width: 750px">
                <v-col cols="12">
                    <b class="ml-3">Choix des éléments à transmettre</b>
                    <!-- <v-row no-gutters class="my-3">
                            <v-col cols="12" class="d-flex justify-center">
                                <v-btn
                                     size="small"

                                    rounded
                                    elevation="0"
                                    class="mr-2 mt-1"
                                    color="primary"
                                    @click="selectAllFormsToSend()"
                                >
                                    Tout sélectionner
                                </v-btn>
                                <v-btn
                                     size="small"

                                    rounded
                                    outlined
                                    elevation="0"
                                    class="ml-2 mt-1"
                                    color="primary"
                                    @click="clearAllFormsToSend()"
                                >
                                    Tout désélectionner
                                </v-btn>
                            </v-col>
                        </v-row> -->
                    <v-row no-gutters>
                        <v-col
                            cols="4"
                            class="d-flex justify-center align-center"
                            v-for="element of sendableElements"
                            :key="element.value"
                        >
                            <v-checkbox
                                :disabled="elementIsDisabled(element)"
                                v-model="formsToSend"
                                :label="element.text"
                                :value="element.value"
                                color="primary"
                            >
                            </v-checkbox>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12">
                    <b class="ml-3">Choix des destinataires</b>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="4" class="d-flex justify-center align-center">
                    <v-checkbox
                        :disabled="!hasCompanyOga"
                        v-model="recipients"
                        value="DGFIP"
                        label="DGFIP"
                        color="primary"
                    >
                    </v-checkbox>
                </v-col>
                <v-col cols="4" class="d-flex justify-center align-center">
                    <v-checkbox
                        :disabled="!hasCompanyOga"
                        v-model="recipients"
                        value="OGA"
                        label="OGA"
                        color="primary"
                    >
                    </v-checkbox>
                </v-col>
            </v-row>
            <v-row no-gutters class="mb-3">
                <v-col cols="12">
                    <b class="ml-3" v-if="isBundleIncludedCVAE && isCVAEeligible"
                        >Les deux feuillets concernant la 1330CVAE vont automatiquement être
                        déplacés dans une nouvelle déclaration courante.</b
                    >
                </v-col>
            </v-row>
            <v-row no-gutters class="mb-3">
                <v-col cols="12">
                    <b class="ml-3"
                        >Après validation, vous serez redirigé(e) vers la page "Mon dossier" pour
                        clôturer l'exercice si vous le souhaitez.</b
                    >
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="generateBookletDialog"
            v-if="generateBookletDialog"
            title="Choix de la plaquette"
            valid-title="Télécharger"
            @valid="generateBooklet()"
            @close="generateBookletDialog = false"
        >
            <v-row no-gutters style="width: 750px">
                <v-checkbox
                    v-model="exportWithProjectWatermark"
                    :ripple="false"
                    class="mb-1"
                    :title="$t('shared.exportWithProjectWatermark')"
                    :label="$t('shared.exportWithProjectWatermark')"
                />
            </v-row>
            <v-row no-gutters style="width: 750px">
                <v-col cols="12" class="d-flex justify-center">
                    <v-select-filled
                        v-model="exportType"
                        :items="[
                            { title: 'PDF', value: 'PDF' },
                            { title: 'Docx', value: 'DOCX' },
                        ]"
                        label="Format d'export"
                        outlined
                        class="mx-2 mt-2"
                        hide-details
                        density="compact"
                    />
                </v-col>
                <!-- <v-col cols="12" class="d-flex justify-center">
                        <v-select-filled v-model="bookletToGenerate" :items="templatesList"
                            label="Choisissez la plaquette à générer" outlined class="mx-2 mt-2" dense
                            hide-details></v-select-filled>
                    </v-col> -->
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="generateConfirmationDialog"
            v-if="generateConfirmationDialog"
            title="Confirmation changement de modèle"
            valid-title="Oui"
            @valid="onConfirmationChangeTemplate()"
            @close="onCloseConfirmationDialog()"
        >
            <v-row no-gutters style="width: 750px">
                <v-col cols="12" class="d-flex justify-center">
                    <div class="pt-2 px-4 pb-4">
                        Les modifications apportées à la plaquette en cours seront définitivement
                        perdues, souhaitez-vous toujours changer de modèle ?
                    </div>
                </v-col>
            </v-row>
        </oss-dialog>
        <oss-dialog
            v-model="instructionsDialog"
            v-if="instructionsDialog"
            height="85%"
            @close="instructionsDialog = false"
        >
            <v-row no-gutters style="width: 750px">
                <v-col cols="12" class="d-flex justify-center">
                    <iframe
                        src="https://docs.google.com/document/d/1dqMm4_AdH_32YrDuTtp7aBoArlcpiPwWweXl1GX5ufQ/edit?pli=1"
                        width="100%"
                        height="750px"
                    >
                    </iframe>
                </v-col>
            </v-row>
        </oss-dialog>
    </div>
</template>
<script lang="ts">
import { Apollo } from "@/decorators";
import { BundleFront } from "@/services/bundle/BundleFront";
import { State2Way } from "@/decorators";
import gql from "graphql-tag";
import moment from "moment-timezone";
import TaxForm from "../TaxForm.vue";
import BundleDetails from "./BundleDetails.vue";
import BookletGenerator from "./BookletGenerator.vue";
import AccountingItemEdition2 from "../../accounting/accountingItem/Edition.vue";
import GeneralLedger from "../../GeneralLedger2.vue";
import TaxFormEDIReport from "../TaxFormEDIReport.vue";
import PROFILE_COMPANY from "@/graphql/company/ProfileCompany.gql";
import BUNDLE_BALANCES from "@/graphql/declaration/BundleBalances.gql";
import LATEST_N1_VALID_BUNDLE from "@/graphql/declaration/LatestN1ValidBundle.gql";
import GENERATE_BUNDLE from "@/graphql/declaration/GenerateBundle.gql";
import DUPLICATE_BUNDLE from "@/graphql/declaration/DuplicateBundle.gql";
import UPDATE_DECLARATIONS_STATUS from "@/graphql/declaration/UpdateDeclarationsStatus.gql";
import BOOKLET_ANNEXES from "../../../../../backend/src/common/bundle/formList/Form_ANNEXES.json";
import { SheetManager } from "../../../../../backend/src/common/taxform/SheetManager";
import Spec from "../../../../../backend/src/common/specs/Spec";
import { NotificationBase } from "../../NotificationBase";
import { newCommonFormatCurrency } from "../../../../../backend/src/common/services/mathServices";
import { DialogAction } from "@/services/dialogAction";
import { GeneralLedgerAccountType } from "../../../../../backend/src/common/bundle/BundleBase";
import getEnv from "@/env";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { Hook } from "vue-facing-decorator";
import { Provide } from "vue-facing-decorator";
import { User } from "@/store/store";
import { Offer_type } from "@/types/offer.types";

const env = getEnv();

@Component({
    components: {
        TaxForm,
        BundleDetails,
        BookletGenerator,
        GeneralLedger,
        AccountingItemEdition2,
        TaxFormEDIReport,
    },
})
export class BundleManager extends NotificationBase {
    @Prop({ default: "" }) id: string;
    @Provide("taxFormFocusFromConsistencyCheck") focusSpec = "";

    @Hook
    beforeRouteLeave(to, from, next) {
        if (this.needSave) {
            // next(false);
            this.confirmCloseWithoutSaveDialog = true;
            this.routerNext = to;
        } else {
            next();
        }
    }

    setFocusSpec(value) {
        this.focusSpec = value;
    }

    needSave: boolean = false;

    bundleId_: string = "";

    confirmCloseWithoutSaveDialog: boolean = false;

    bundleDeclarationDialog: boolean = false;

    fixedAssetsErrorDialog: boolean = false;

    routerNext: any = {};

    checksDialog: boolean = false;

    generalLedgerDialog: boolean = false;

    dependenciesErrorsDialog: boolean = false;

    checksWindow: string = "allChecks";

    miscellaneousOperationDialog: boolean = false;
    miscellanousOperationData: any = [];

    selectedYear: string = new Date().getFullYear().toString();
    selectedTaxFormIndex: number = 0;

    selectedView: string = "bundle";

    enableEdition: boolean = false;

    loaded: boolean = false;

    // bookletGeneratorDialog: boolean = false;
    addFormDialog: boolean = false;

    printFormsDialog: boolean = false;

    searchForm: string = "";

    allFields: { [key: string]: Spec } = {};
    toSendDependencied: { [k: string]: Function[] } = {};

    formDisplayMode: "TaxFormTable" | "TaxFormPng" = "TaxFormTable";

    printFormsMode: "html" | "png" = "png";

    bundle: BundleFront = null;

    formsSelected = [];

    formsToSend = [];

    recipients = [];

    // fixedVariables: { key: string; value: string | number | boolean }[] = [];

    fixedVariables: { [key: string]: string | number | boolean } = null;

    // balanceErrors = {
    //     missingAasInAccountingBalance: [],
    //     aasWithdifferentBalance: [],
    //     missingAasInBundleBalance: [],
    // };

    fixedAssetsError = {};

    fixedVariablesErrors = {};

    showAllConsistencyChecks: boolean = false;

    referencedFormRefreshKey = 0;

    sendBundleDialogLoading: boolean = false;

    generateBookletDialog: boolean = false;

    selectedTemplateTemp: any = null;
    generateConfirmationDialog: boolean = false;

    instructionsDialog: boolean = false;

    toDeleteSheet: any = undefined;
    toDeleteDialog: boolean = false;

    bookletToGenerate: string = "";

    selectedBookletTemplateId: string = "";
    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    exportType = "PDF";

    exportWithProjectWatermark = false;

    wantToDeclare: boolean = false;

    accountsBalanceAnomalies: GeneralLedgerAccountType[] = [];
    accountsBalanceAnomaliesCount: number = 0;

    missingTaxNumberSCIAssociates: boolean = false;

    duplicateBundleLoading: boolean = false;

    wantToRefreshGeneralLedger: boolean = false;
    generalLedgerHasBeenSet: boolean = false;

    newCommonFormatCurrency(value, option) {
        return newCommonFormatCurrency(value, option);
    }

    @State2Way("updateSelectedAccountingPeriod", "accountingPeriod.selectedAccountingPeriod")
    accountingPeriod: any;

    @Watch("selectedView")
    onSelectedViewChange() {
        if (this.selectedView === "booklet") {
            this.formDisplayMode = "TaxFormTable";
        }
        this.computeReferencedForms();
    }

    @Watch("selectedTaxFormIndex")
    onSelectedTaxFormIndexChange(val: number) {
        if (val < 0) {
            this.selectedTaxFormIndex = 0;
        }
    }

    // resetSelectedForm(value) {
    //     this.selectedTaxFormIndex = 0;
    //     if (["bundle"].includes(value)) {
    //         return;
    //     }
    //     if (this.bookletTemplates) {
    //         this.bundle.bookletTemplate = cloneDeep(
    //             this.bookletTemplates.find((bt) => bt.id === value),
    //         );
    //         this.selectedTemplateTemp = this.bundle.bookletTemplate;
    //     } else {
    //         this.selectedTemplateTemp = null;
    //     }
    // }

    get offerType(): Offer_type {
        return this.$store.state.offerType;
    }

    get isTrainingOffer(): boolean {
        if (this.offerType === Offer_type.TRAINING) {
            return true;
        }
        return false;
    }

    get sendableElements() {
        let elements = [];
        if (["BICRNP", "BICRSP", "BNC", "BARNA"].includes(this.bundle?.bundleType)) {
            elements = [
                { text: "Liasse", value: "Bundle" },
                { text: "Tableaux OG", value: "OGTables" },
                { text: "Balance", value: "Balances" },
            ];
        } else if (["BARSA"].includes(this.bundle?.bundleType)) {
            elements = [
                { text: "Liasse", value: "Bundle" },
                { text: "Balance", value: "Balances" },
            ];
        } else {
            elements = [{ text: "Liasse", value: "Bundle" }];
        }
        if (this.isBundleIncludedCVAE) {
            elements.push({ text: "CVAE", value: "CVAE" }); // 1330CVAE
        }
        if (elements.length === 1) {
            this.formsToSend = ["Bundle"];
        }
        return elements;
    }

    get bundleId() {
        if (this.bundleId_) {
            return this.bundleId_;
        }
        return this.id;
    }

    get companyId() {
        return this.company?.id || null;
    }

    get company() {
        return this.$store.state.selected_company;
    }

    get currentUser(): User {
        return this.$store.state.user;
    }

    get userId() {
        return this.currentUser?.id;
    }

    get isAccountingCustomer() {
        return this.currentUser?.profile?.name === "accounting-customer";
    }

    get filteredOptionalForms() {
        if (this.searchForm) {
            return this.optionalForms.filter((form) => {
                return (
                    form.title.toLowerCase().includes(this.searchForm.toLowerCase()) ||
                    form.cerfa.toLowerCase().includes(this.searchForm.toLowerCase())
                );
            });
        }
        return this.optionalForms;
    }

    get firstTabTitle() {
        if (this.selectedView === "bundle") {
            return "Dossier Permanent";
        }
        return "Détail";
    }

    get accountingPeriodId() {
        return this.accountingPeriod ? this.accountingPeriod.id : "";
    }

    get years() {
        return ["2021", "2020", "2019"];
    }

    // get views() {
    //     return [
    //         { text: "Liasse", value: "bundle" },
    //         { text: "Plaquette", value: "booklet" },
    //     ];
    // }

    get viewsToDisplay(): { text: string; value: string }[] {
        let list: { text: string; value: string }[] = [];
        if (this.isAccountingCustomer) {
            list = [{ text: "Liasse", value: "bundle" }];
        } else {
            list = [
                { text: "Liasse", value: "bundle" },
                { text: "Plaquette", value: "booklet" },
            ];
        }
        return list;
    }

    get bookletTemplateList() {
        const list = [];
        for (const bookletTemplate of this.bookletTemplates) {
            list.push({ text: bookletTemplate.name, value: bookletTemplate.id });
        }

        return list;
    }

    get selectedTemplate() {
        if (!this.loaded) {
            return null;
        }
        return this.bookletTemplates.find((bt) => bt.id === this.selectedView);
    }

    bookletTemplate = null;

    // get templatesList() {
    //     if (!this.loaded) {
    //         return null;
    //     }

    //     return this.bookletTemplates.map((bt) => ({ text: bt.name, value: bt.id }));
    // }

    get isBalanceError() {
        if (
            this.balanceErrors.aasWithdifferentBalance.length ||
            this.balanceErrors.missingAasInAccountingBalance.length ||
            this.balanceErrors.missingAasInBundleBalance.length
        ) {
            return true;
        }
        return false;
    }

    get isFixedAssetsError() {
        if (!this.bundle) return false;
        if (this.bundle.fixedAssetsError) {
            return true;
        }
        return false;
    }

    get isSendBundleDisabled(): boolean {
        if (
            !this.loaded ||
            this.isSent ||
            this.needSave ||
            this.bundle?.unaffectedAccounts?.length
        ) {
            return true;
        }
        return false;
    }

    get bundleType() {
        const { incomeCategory, taxRegime, taxSystemType } = this.$store.state.selected_company;
        if (incomeCategory === "BIC" && taxRegime === "REAL_NORMAL") {
            if (taxSystemType === "IS") {
                return "RN_IS";
            }
            if (taxSystemType === "IR") {
                return "RN_IR";
            }
        }
        if (incomeCategory === "BIC" && taxRegime === "REAL_SIMPLIFIED") {
            if (taxSystemType === "IS") {
                return "RS_IS";
            }
            if (taxSystemType === "IR") {
                return "RS_IR";
            }
        }
        if (incomeCategory === "BNC") {
            return "BNC";
        }
        if (incomeCategory === "RF") {
            return "RF";
        }
        if (incomeCategory === "BA" && taxRegime === "REAL_NORMAL") {
            return "RNA";
        }
        if (incomeCategory === "BA" && taxRegime === "REAL_SIMPLIFIED") {
            return "RSA";
        }
        return "";
    }

    get errorsCount(): number {
        if (this.loaded) {
            let count = 0;
            if (this.bundle) {
                count += this.bundle.invalidChecksCount;
                count += this.invalidFixedVariablesCount;
                count += this.accountsBalanceAnomaliesCount;
                if (this.isFixedAssetsError) {
                    count++;
                }
                if (this.isBalanceError) {
                    count++;
                }
                if (this.bundle.unaffectedAccounts.length) {
                    count++;
                }
                if (this.missingTaxNumberSCIAssociates) {
                    count++;
                }
            }
            return count;
        }
        return 0;
    }

    set errorsCount(data) {}

    get invalidFixedVariablesCount() {
        let count = 0;
        if (
            this.fixedVariables &&
            (!this.fixedVariables.Y1 ||
                !this.fixedVariables.Y2 ||
                !this.fixedVariables.signatureCity)
        ) {
            count++;
        }
        return count;
    }

    get filteredConsistencyChecks(): { [key: string]: any } {
        if (!this.bundle.showAllConsistencyChecks) {
            const checksToValidate = {};
            for (const key of Object.keys(this.bundle.consistencyChecksManager.fields)) {
                if (
                    key.startsWith("check") &&
                    !this.bundle.consistencyChecksManager.fields[key].isValid
                ) {
                    checksToValidate[key] = this.bundle.consistencyChecksManager.fields[key];
                }
            }
            return checksToValidate;
        }
        return this.bundle.consistencyChecksManager.fields;
    }

    get checksDialogValidTitle() {
        if (this.checksWindow === "balanceErrors") {
            return "Recalculer la liasse à partir de la nouvelle balance";
        } else if (this.wantToDeclare) {
            return "Télédéclarer quand même ";
        }
        return "Fermer";
    }

    get allSelected() {
        const allForms = this.referencedForms;
        if (allForms && this.formsSelected && this.formsSelected.length === allForms.length) {
            return true;
        }
        return false;
    }

    get hasCompanyOga() {
        if (!this.settingsVariables.ogaEnrolment) {
            this.recipients = ["DGFIP"];
        }
        return this.settingsVariables.ogaEnrolment;
    }

    get isSaveDisabled() {
        if (!this.needSave) {
            return true;
        }
        if (!this.loaded) {
            return true;
        }
        if (this.isSent && this.selectedView === "bundle") {
            return true;
        }
        return false;
    }

    get companyBundleType() {
        if (this.company) {
            if (this.company.incomeCategory === "BIC") {
                if (this.company.taxRegime === "REAL_NORMAL") {
                    if (this.company.taxSystemType === "IS") {
                        return "BICRNS";
                    }
                    if (this.company.taxSystemType === "IR") {
                        return "BICRNP";
                    }
                } else if (this.company.taxRegime === "REAL_SIMPLIFIED") {
                    if (this.company.taxSystemType === "IS") {
                        return "BICRSS";
                    }
                    if (this.company.taxSystemType === "IR") {
                        return "BICRSP";
                    }
                }
            }
            if (this.company.incomeCategory === "BNC") {
                return "BNC";
            }
            if (this.company.incomeCategory === "RF") {
                return "SCI";
            }
            if (this.company.incomeCategory === "BA") {
                if (this.company.taxRegime === "REAL_NORMAL") {
                    return "BARNA";
                }
                if (this.company.taxRegime === "REAL_SIMPLIFIED") {
                    return "BARSA";
                }
            }
        }
        return "";
    }

    get bundleDependenciesErrors() {
        if (this.loaded && this.bundle?.allDependenciesErrors?.length) {
            return this.bundle.allDependenciesErrors;
        }
        return null;
    }

    get isSent() {
        return this.bundle?.isSent || false;
    }

    checksDialogValidFunction() {
        if (this.checksWindow === "balanceErrors") {
            this.refreshGeneralLedger();
            this.checksWindow = "allChecks";
        }
        if (this.wantToDeclare === true) {
            this.bundleDeclarationDialog = true;
        }
        this.toggleChecksDialog();
    }

    beforeMount() {
        if (!this.bundleId) {
            this.needSave = true;
        }
        this.addListener("accountingItemExport");
    }

    onMessage(data: any): void {}

    openAddFormDialog() {
        this.addFormDialog = true;
    }

    openPrintFormsDialog(allForms: boolean = false) {
        this.formsSelected = [];
        if (this.selectedTaxFormIndex !== 0) {
            this.formsSelected[0] = this.referencedForms[this.selectedTaxFormIndex - 1].cerfaNumber;
        }
        if (allForms === true) {
            this.formsSelected = this.referencedForms.map((form) => form.cerfaNumber);
            this.printForms();
        } else {
            this.printFormsDialog = true;
        }
    }

    async updateDeclarationStatus() {
        await this.$apollo.mutate({
            mutation: UPDATE_DECLARATIONS_STATUS,
            variables: {
                ids: [this.bundleId],
            },
        });
        if (this.$apollo?.queries?.form) {
            await this.$apollo.queries.form.refetch();
        }
    }

    selectAll() {
        this.formsSelected = this.referencedForms.map((form) => form.cerfaNumber);
    }

    clearAll() {
        this.formsSelected = [];
    }

    selectAllFormsToSend() {
        this.formsToSend = this.sendableElements.map((el) => el.value);
    }

    clearAllFormsToSend() {
        this.formsToSend = [];
    }

    getTemplateName(templateId) {
        const template = this.bookletTemplates.find((bt) => bt.id === templateId);
        return template?.name || "Sans titre";
    }

    referencedSheets = [];

    getReferencedSheets() {
        if (this.bundle) {
            this.referencedSheets = this.bundle.referencedSheets;
        } else {
            this.referencedSheets = [];
        }
        this.computeReferencedForms();
    }

    referencedForms: any[] = [];

    computeReferencedForms() {
        if (!this.bundle) {
            debugger;
            this.referencedForms = [];
            return;
        }
        if (this.referencedSheets?.length) {
            if (this.selectedView === "bundle") {
                this.referencedForms = this.referencedSheets.filter(
                    (rs) => !BOOKLET_ANNEXES.find((ba) => ba.cerfa === rs.cerfaNumber),
                );
            } else {
                this.referencedForms = this.referencedSheets.filter(
                    (rs) =>
                        BOOKLET_ANNEXES.find((ba) => ba.cerfa === rs.cerfaNumber) &&
                        this.selectedTemplateTemp?.content?.pages?.find(
                            (page) => page.cerfa === rs.cerfaNumber,
                        ),
                );
            }
        } else {
            debugger;
            this.referencedForms = [];
        }
    }

    get optionalForms() {
        if (!this.bundle) {
            return [];
        }
        return this.bundle.optionalForms(); //BundleFront.optionalForms();
    }

    @Apollo({
        query: PROFILE_COMPANY,
        variables() {
            return {
                id: this.company?.profile?.id,
            };
        },
        skip() {
            return !this.company?.profile?.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data?.profileCompany?.ogaEnrolment !== null) {
                    this.settingsVariables = {
                        ogaEnrolmentConfig: {
                            address: data.profileCompany.ogaEnrolmentConfig?.address,
                            postalCode: data.profileCompany.ogaEnrolmentConfig?.postalCode,
                            city: data.profileCompany.ogaEnrolmentConfig?.city,
                            designation: data.profileCompany.ogaEnrolmentConfig?.designation,
                            numberId: data.profileCompany.ogaEnrolmentConfig?.numberId,
                            siret: data.profileCompany.ogaEnrolmentConfig?.siret,
                            year: data.profileCompany.ogaEnrolmentConfig?.year,
                        },
                        ogaEnrolment: data.profileCompany.ogaEnrolment,
                        taxSystem: {
                            income: this.company.incomeCategory,
                            regime: this.company.taxRegime,
                            type: this.company.taxSystemType,
                        },
                    };
                }
            }
        },
    })
    settingsVariables: {
        ogaEnrolment: boolean;
        taxSystem: {
            income: string;
            regime: string;
            type: string;
        };
        ogaEnrolmentConfig: {
            address: string;
            postalCode: string;
            city: string;
            designation: string;
            numberId: string;
            siret: string;
            year: string;
        };
    } = {
        ogaEnrolment: null,
        taxSystem: {
            income: null,
            regime: null,
            type: null,
        },
        ogaEnrolmentConfig: {
            address: null,
            postalCode: null,
            city: null,
            designation: null,
            numberId: null,
            siret: null,
            year: null,
        },
    };

    @Apollo({
        query: BUNDLE_BALANCES,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
            };
        },
        skip() {
            if (this.bundle?.balances) {
                return (
                    !this.companyId || !this.accountingPeriodId || !this.wantToRefreshGeneralLedger
                );
            }
            return !this.companyId || !this.accountingPeriodId;
        },
        async specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                if (data.bundleBalances?.balances) {
                    const balances = data.bundleBalances.balances;
                    if (!balances.length) {
                        this.balances = [];
                        return;
                    }
                    this.balances = balances;
                    if (this.wantToRefreshGeneralLedger) {
                        this.wantToRefreshGeneralLedger = false;
                    }
                } else {
                    this.balances = [];
                }
                this.display = true;
            } else {
                this.balances = [];
            }
        },
    })
    balances: any[] = [];

    @Apollo({
        query: LATEST_N1_VALID_BUNDLE,
        variables() {
            return {
                companyId: this.companyId,
                accountingPeriodStartN: this.accountingPeriod.start,
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriod;
        },
        async specificResult({ data, loading, networkStatus }: any) {
            if (data) {
                this.latestN1ValidBundle = data.latestN1ValidBundle;
            }
        },
    })
    latestN1ValidBundle: any = null;

    bookletTemplates: any = null;

    refreshGeneralLedger() {
        this.wantToRefreshGeneralLedger = true;
        if (this.generalLedgerHasBeenSet) {
            this.generalLedgerHasBeenSet = false;
        }
        this.miscellanousOperationData = [];
        if (this.$apollo.queries?.balances) {
            this.$apollo.queries.balances.refetch();
        }
        this.needSave = true;
    }

    async formToAdd(form: any, update: boolean = true) {
        if (form.forms) {
            for (let index = 0; index < form.forms.length; index++) {
                const f = form.forms[index];
                await this.formToAdd(f, index === form.forms.length - 1);
            }
            return;
        }
        const bundleSheet = await this.bundle.addBundleSheet(
            {
                id: "",
                cerfa: form.cerfa,
                year: this.selectedYear,
            },
            true,
            false,
        );
        //
        // DO NOT MODIFY TO ENABLE VUEJS REACTIVITY
        //
        // this.bundle.bundleSheets = { ...this.bundle.bundleSheets, [form.cerfa]: bundleSheet };

        // this.selectedTaxFormIndex = 0;
        if (update) {
            if (bundleSheet) {
                this.additionnalPageCreated(bundleSheet.cerfaNumber);
                this.referencedFormRefreshKey++;
            }
            // this.showCellToCheck(form.cerfa);
            this.addFormDialog = false;
        }
    }

    getBundleSheets(cerfa: string) {
        // if (cerfa.startsWith("A")) {
        // }
        if (!this.bundle?.bundleSheets) {
            return null;
        }
        return this.bundle.getBundleSheets(cerfa);
    }

    fixedVariablesUpdated(result) {
        let needUpdate: boolean = false;
        if (this.fixedVariables?.C5 !== result.fixedVariables?.C5) {
            needUpdate = true;
        }
        this.fixedVariables = result.fixedVariables;
        this.needSave = true;
        if (this.loaded) {
            this.bundle.setFixedVariables(this.fixedVariables);
            if (needUpdate) {
                this.bundle.updateDependencies();
                this.bundle.update();
            }
        }
    }

    fixedVariablesFetched(result) {
        this.fixedVariables = result.fixedVariables;
        if (this.loaded) {
            this.bundle.setFixedVariables(this.fixedVariables);
        }
    }

    // openBookletGenerator() {
    //     this.bookletGeneratorDialog = true;
    // }

    // setBookletTemplate(bookletTemplates) {
    //     this.bookletTemplates = bookletTemplates;
    //     for (const bt of this.bookletTemplates) {
    //         for (const annex of bt.content.pages) {
    //             if (!annex || !annex.form) {
    //                 console.error("annex without form cerfa= ", annex.cerfa);
    //                 continue;
    //             }
    //             if (
    //                 BOOKLET_ANNEXES.some((ba) => ba.cerfa === annex.cerfa) &&!this.bundle.bundleSheets[annex.cerfa]
    //             ) {
    //                 this.bundle.addBundleSheet(
    //                     new SheetManager(
    //                         "",
    //                         annex.form,
    //                         this.bundle.radicals,
    //                         this.bundle,
    //                         null,
    //                         false,
    //                         annex.form.values
    //                     ),
    //                     false
    //                 );
    //             }
    //         }
    //     }
    // }

    async generateBooklet() {
        if (this.needSave) {
            await this.saveBundle();
        }
        const result: any = await this.$apollo.mutate({
            mutation: gql`
                mutation exportTaxFormBooklet(
                    $companyId: ID!
                    $accountingPeriodId: ID!
                    $bundleId: ID!
                    $exportType: String
                    $importFilesMillesimFromBundle: String
                    $watermark: String
                ) {
                    exportTaxFormBooklet(
                        data: {
                            companyId: $companyId
                            accountingPeriodId: $accountingPeriodId
                            bundleId: $bundleId
                            # content: $content,
                            exportType: $exportType
                            importFilesMillesimFromBundle: $importFilesMillesimFromBundle
                            watermark: $watermark
                        }
                    ) {
                        output
                    }
                }
            `,
            variables: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                bundleId: this.bundleId,
                // content: this.bundle.bookletTemplate.content,
                exportType: this.exportType,
                importFilesMillesimFromBundle: this.bundle?.importFilesMillesim,
                watermark: this.exportWithProjectWatermark ? this.$t("shared.draft") : undefined,
            },
        });
        // if (!result?.data) {
        // }
        this.generateBookletDialog = false;
        this.bookletToGenerate = "";
    }

    openBundleDeclarationDialog() {
        if (
            this.balanceErrors.aasWithdifferentBalance.length ||
            this.balanceErrors.missingAasInAccountingBalance.length ||
            this.balanceErrors.missingAasInBundleBalance.length
        ) {
            this.throwErrorDialog();
        } else if (!this.bundle.allChecksValid) {
            this.wantToDeclare = true;
            this.checksDialog = true;
        } else {
            this.bundleDeclarationDialog = true;
        }
    }

    // fieldUpdate() {
    //     this.bundle.update();
    // }

    async generateXML() {
        this.sendBundleDialogLoading = true;
        if (!this.bundleId) {
            await this.saveBundle();
        }
        await this.$apollo.mutate({
            mutation: GENERATE_BUNDLE,
            variables: {
                bundleId: this.bundleId,
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                userId: this.userId,
                recipients: this.recipients,
                forms: this.formsToSend,
                year: this.selectedYear,
            },
        });
        // this.sendBundleDialogLoading = false;
        // this.bundleDeclarationDialog = false;
        this.goToCompanyPage();
    }

    testTaxForm() {
        this.bundle;
        debugger;
    }

    async printForm() {
        if (
            this.selectedTaxFormIndex < 0 ||
            this.selectedTaxFormIndex >= this.referencedSheets.length
        ) {
            return;
        }
        const sheet = this.referencedSheets[this.selectedTaxFormIndex];

        const bundleSheets: SheetManager | SheetManager[] = sheet;

        if (!bundleSheets) return;

        let toPrintElement = "";

        // let printMode = this.printFormsMode

        if (Array.isArray(bundleSheets)) {
            for (const bundleSheet of bundleSheets) {
                toPrintElement += await bundleSheet.getStaticHtml(this.printFormsMode);
                toPrintElement += "<div style='page-break-after: always;'></div>";
                // break page
            }
        } else {
            toPrintElement = await bundleSheets.getStaticHtml(this.printFormsMode);
        }

        if (toPrintElement) {
            const WinPrint = window.open(
                "",
                "",
                "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
            );

            WinPrint?.document.write(`<!DOCTYPE html>
            <html>
            <head>
                <title>Impression - ${sheet.cerfaNumber}</title>
                <style>
                    body {
                        font-family: "Roboto", sans-serif;
                        font-size: 12px;
                        margin: 5mm;
                    }
                </style>
            </head>
            <body>
                ${toPrintElement}
            </body>
            </html>`);

            let delay = 300;
            if (bundleSheets instanceof Array) {
                delay = bundleSheets.length * 300;
            }

            await setTimeout(() => {
                WinPrint?.print();
                WinPrint?.document.close();
            }, delay);
            // WinPrint?.print();
            // WinPrint?.document.close();
        }
    }

    async printForms() {
        if (this.formsSelected?.length) {
            let toPrintElement = "";

            for (const cerfaNumber of this.formsSelected) {
                // let bundleSheets: BundleSheetManager | BundleSheetManager[] =
                // this.getBundleSheet(form);
                // let bundleSheets = this.formsSelected

                // if (!bundleSheets) return;
                const bundleSheet = this.referencedForms.find(
                    (rf) => rf.cerfaNumber === cerfaNumber,
                );
                if (!bundleSheet) {
                    debugger;
                    continue;
                }

                // let printMode: "html" | "png" = this.formDisplayMode === "TaxFormTable" ? "html" : "png";

                // if (Array.isArray(bundleSheets)) {
                // for (const bundleSheet of bundleSheets) {
                toPrintElement += await bundleSheet.getStaticHtml(this.printFormsMode);
                toPrintElement += "<div style='page-break-after: always;'></div>";
                // break page
                // }
                // } else {
                //     toPrintElement += await bundleSheets.getStaticHtml(this.printFormsMode);
                //     toPrintElement += "<div style='page-break-after: always;'></div>";
                // }
            }

            if (toPrintElement) {
                const WinPrint = window.open(
                    "",
                    "",
                    "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0",
                );

                WinPrint.document.write(`<!DOCTYPE html>
                <html>
                <head>
                    <title>
                        ${this.exportWithProjectWatermark ? this.$t("shared.draft") + " - " : ""} 
                        Liasse fiscale - 
                        ${this.company.name} - 
                        ${moment(this.accountingPeriod.end).format("DDMMYYYY")}
                    </title>
                    <style>
                        body {
                            font-family: "Roboto", sans-serif;
                            font-size: 12px;
                            margin: 5mm;
                            -webkit-print-color-adjust: exact !important;
                            color-adjust: exact !important;
                            print-color-adjust: exact !important;
                        }
                        ${this.exportWithProjectWatermark ? this.addWatermarkCss(this.$t("shared.draft")) : ""}
                    </style>
                </head>
                <body>
                    ${toPrintElement}
                </body>
                </html>`);

                WinPrint.onload = () => {
                    WinPrint.print();
                };

                WinPrint.document.close();
                // WinPrint.focus();

                const checkWindowClosed = setInterval(() => {
                    if (WinPrint.closed) {
                        clearInterval(checkWindowClosed);
                        this.printFormsDialog = false;
                    }
                }, 100);
            }
        }
    }

    addWatermarkCss(watermark: string) {
        return `
        body::before {
            content: '${watermark}';
            position: absolute;
            top: 50%;
            left: 0;
            width: 100%;
            transform: translateY(-50%) rotateZ(-45deg);
            text-align: center;
            font-size: 170px;
            color: rgba(40, 40, 40, .35);
        }`;
    }

    isOptionnalForm(cerfa: string) {
        return this.optionalForms.findIndex((form) => form.cerfa === cerfa) !== -1;
    }

    exit() {
        this.$router.push(this.routerNext).catch(() => {});
    }

    async saveAndExit() {
        await this.saveBundle();
        this.exit();
        this.resetRouterNext();
    }

    resetRouterNext() {
        this.routerNext = "";
    }

    async saveBundle() {
        if (this.bundleId && !this.bundle.isBookletTemplatePersonalized) {
            await this.bundle.saveBundle();
            this.needSave = false;
        } else {
            this.bundleId_ = await this.bundle.saveBundle();
            // to refresh sheets after first save
            await this.bundle.getBundle();
            await this.bundle.generateSheets();

            if (this.bundle.isBookletTemplatePersonalized) {
                //Poser question Antho
                this.generateBundle();
            }
            //
            this.needSave = false;
            this.$router.replace({
                name: "taxForm2",
                params: { id: this.bundleId_ },
                replace: true,
            });
        }
    }

    toggleChecksDialog() {
        this.checksDialog = !this.checksDialog;
        this.wantToDeclare = false;
    }

    toggleDependenciesErrorsDialog() {
        this.dependenciesErrorsDialog = !this.dependenciesErrorsDialog;
    }

    openGeneralLedger() {
        this.generalLedgerDialog = true;
    }

    showCellToCheck(inCerfa) {
        // const toAdd = this.bundle.bundleType === "BNC" ? 1 : 0;
        let cerfa = inCerfa;
        if (cerfa === "2035SA" || cerfa === "2035SB") {
            cerfa = "2035SUITE";
        }

        this.selectedTaxFormIndex =
            this.referencedForms.findIndex((sheet) => sheet.cerfaNumber === cerfa) + 1;
        if (this.checksDialog === true) {
            this.toggleChecksDialog();
        }
    }

    formatConsistencyChecksError(error: number | string | boolean) {
        if (typeof error === "string") {
            return error.replaceAll("&mdash;", "—");
        }
        return error;
    }

    back() {
        this.$router.push({ name: "taxFormsTab", params: { selectedWindow: "taxDeclarations" } });
    }

    goToCompanyPage() {
        this.$router.push({ name: "companyEdition", params: { companyId: this.companyId } });
    }

    createRows() {
        this.miscellanousOperationData = [];

        const mainRow = {
            date: this.accountingPeriod.end,
            dueDate: "",
            accountableAccount: { name: "" },
            wording: "",
            netAmount: 0.0,
            debit: 0.0,
            credit: 0.0,
        };

        const secondRow = {
            date: this.accountingPeriod.end,
            dueDate: "",
            accountableAccount: { name: "" },
            wording: "",
            netAmount: 0.0,
            debit: 0.0,
            credit: 0.0,
        };

        this.miscellanousOperationData.push(JSON.parse(JSON.stringify(mainRow)));

        this.miscellanousOperationData.push(JSON.parse(JSON.stringify(secondRow)));
    }

    additionnalPageCreated(cerfaNumber) {
        this.getReferencedSheets();
        this.selectedTaxFormIndex =
            this.referencedForms.findIndex((sheet) => sheet.cerfaNumber === cerfaNumber) + 1;
        this.referencedFormRefreshKey++;
        this.needSave = true;
    }

    @Watch("isBalanceError")
    throwErrorDialog() {
        if (this.isBalanceError && !this.isSent) {
            this.toggleChecksDialog();
            this.checksWindow = "balanceErrors";
        }
    }

    get balanceErrors() {
        if (this.bundle) {
            return this.bundle.compareBalances(this.balances);
        }
        return {
            missingAasInAccountingBalance: [],
            aasWithdifferentBalance: [],
            missingAasInBundleBalance: [],
        };
    }

    @Watch("balances", { deep: true, immediate: true })
    // @Watch("fixedVariables")
    @Watch("bundleId")
    @Watch("settingsVariables", { deep: true })
    async generateBundle() {
        if (this.isSent) {
            debugger;
        }
        if (!this.companyId) {
            debugger;
            return;
        }
        if (!this.balances?.length) {
            return;
        }
        if (this.settingsVariables?.ogaEnrolment === null) {
            debugger;
            return;
        }
        this.loaded = false;
        if (!this.bundle) {
            this.bundle = await BundleFront.instanciate(
                this.companyId,
                this.accountingPeriodId,
                this.userId,
                this.bundleId,
            );
        } else if (!this.generalLedgerHasBeenSet) {
            this.bundle.setBalances(this.balances);
            this.generalLedgerHasBeenSet = true;
            await this.bundle.generateSheets();
        }
        if (this.fixedVariables) {
            this.fixedVariables.V6 = this.bundle.getV6FixedVariable();
            this.fixedVariables.D1 = this.bundle.getD1FixedVariable();
            this.bundle.setFixedVariables(this.fixedVariables);
        }
        // this.bundle.setBundleN1();
        if (this.latestN1ValidBundle) {
            await this.bundle.setPreviousDeficitsCarriedForward(this.latestN1ValidBundle);
            await this.bundle.setSubsidiaries(this.latestN1ValidBundle);
        }
        this.accountsBalanceAnomalies = this.bundle.checkAccountsBalance(this.balances);
        this.accountsBalanceAnomaliesCount = this.accountsBalanceAnomalies.length;
        this.missingTaxNumberSCIAssociates = this.bundle.checkTaxNumberSCIAssociates(
            this.company.taxSystemType,
        );
        this.bookletTemplates = await this.bundle.getBookletTemplates();
        if (this.bundle.bookletTemplate) {
            if (
                this.bookletTemplates.find((e) => e.id === this.bundle.bookletTemplate.id) ===
                undefined
            ) {
                this.bookletTemplates.unshift(this.bundle.bookletTemplate);
            }
        } else {
            this.bundle.bookletTemplate = this.bookletTemplates?.[0] || null;
        }
        this.selectedTemplateTemp = this.bundle.bookletTemplate;
        // if (!this.bundleId) {
        // this.setBookletTemplate(this.bookletTemplates)
        // }
        await this.bundle.loadAnnexes(true);
        this.loaded = true;
        this.getReferencedSheets();
    }

    isMandatoryForm(cerfaNumber: string) {
        return this.bundle?.isMandatoryForm(cerfaNumber);
    }

    openDialogToDeleteBundleSheetFromForm(sheet) {
        this.toDeleteSheet = sheet;
        this.toDeleteDialog = true;
    }

    async deleteBundleSheet() {
        await this.bundle.deleteSheet(this.toDeleteSheet);
        this.getReferencedSheets();
        this.referencedFormRefreshKey++;
        this.toDeleteDialog = false;
    }

    onTaxFormChanged() {
        this.needSave = true;
        // this.bundle.updateDependencies() // otherwise links between sheets are not fully functional (e.g. '@:' functions)
        // const BC_before_update = Spec.getValue(this.bundle.bundleSheets["A74"].fields["BC"])
        // debugger
        this.bundle.update();
        // const BC_after_update = Spec.getValue(this.bundle.bundleSheets["A74"].fields["BC"])
        // debugger
    }

    // sheetsOfForm(cerfa: string) {
    //     if (!cerfa) return [];
    //     const exeptions = ["2035"];
    //     const sheets = this.bundle.bundleSheets;
    //     const results = [];
    //     for (const sheet in sheets) {
    //         if (exeptions.includes(cerfa)) {
    //             if (sheet == cerfa) {
    //                 results.push(sheet);
    //             }
    //             continue;
    //         }

    //         if (sheet.includes(cerfa)) {
    //             results.push(sheet);
    //         }
    //     }
    //     return results;
    // }

    displayCerfaName(sheet) {
        switch (sheet.cerfaNumber) {
            case "2035SA":
                return "2035 Suite";
        }
        let [cerfa, repeatNumber] = sheet.cerfaNumber.split("_");
        if (!repeatNumber && sheet.repeatNumber) {
            repeatNumber = sheet.repeatNumber;
        }
        if (repeatNumber && repeatNumber !== 1) {
            return `${cerfa} (${+repeatNumber})`;
        }
        return cerfa;
    }

    cleanSheetTitle(sheet) {
        return sheet.title?.replace(/^(?:.{0,6}[:-]\s*)?/, "") || "";
    }

    notDisplay(sheetName: string) {
        const notToDiaplyList = ["2035SB"];
        return notToDiaplyList.includes(sheetName);
    }

    async duplicateBundle() {
        this.saveBundle();
        this.duplicateBundleLoading = true;
        try {
            await this.$apollo.mutate({
                mutation: DUPLICATE_BUNDLE,
                variables: {
                    id: this.bundleId,
                },
            });
        } catch (error) {
            console.error(error);
        }
        this.duplicateBundleLoading = false;
        this.back();
    }

    onBookletChange(newContent) {
        if (this.bundle.bookletTemplate.content !== newContent) {
            this.bundle.bookletTemplate.content = newContent;
            this.needSave = true;
        }
        this.bundle.bookletTemplateIsPersonalized();
    }

    onBookletTemplateChange() {
        this.generateConfirmationDialog = true;
    }

    onCloseConfirmationDialog() {
        this.selectedTemplateTemp = this.bundle.bookletTemplate;
    }

    async onConfirmationChangeTemplate() {
        this.generateConfirmationDialog = false;
        this.bundle.bookletTemplate = this.selectedTemplateTemp;
        this.needSave = true;
        await this.bundle.loadAnnexes(true);
        this.getReferencedSheets();
    }

    get isUserAuthorized() {
        const email = this.$store.state.user.email;
        if (email?.includes("@oss360.com")) {
            return true;
        }
        return false;
    }

    get xml() {
        return this.bundle?.bundle?.data?.file || null;
    }

    downloadXMLFile() {
        if (this.xml) {
            const blob = new Blob([this.xml], { type: "text/xml" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = "fichier.xml";
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);
        }
    }

    get isBundleIncludedCVAE(): boolean {
        return this.bundle?.isBundleIncludedCVAE;
    }

    get isCVAEeligible(): boolean {
        return this.bundle?.isCVAEeligible;
    }

    elementIsDisabled(element: { value: string }) {
        if (this.sendableElements.length === 1) {
            return true;
        }
        if (element.value === "CVAE" && !this.isCVAEeligible) {
            return true;
        }
        return false;
    }

    shareQuantityDifferenceIsOverZero: boolean = false;

    get shareCapitalIsNotFullyAllocated() {
        if (["RN_IS", "RN_IR", "RS_IS", "RS_IR", "RSA"].includes(this.bundleType)) {
            return this.shareQuantityDifferenceIsOverZero;
        }
        return false;
    }
}

export default toNative(BundleManager);
</script>
<style>
.long-subtitle {
    white-space: normal;
    -webkit-line-clamp: none !important;
    line-clamp: none !important;
}
</style>
